import type { Prototype } from "../prototype-types";

export const austinDickPrototypes: Prototype[] = [
  {
    id: "ad-product-templates-for-brands",
    name: "Product Templates for brands",
    path: "/ad/product-templates-for-brands",
    description:
      "A new workflow for brands to create product templates and use them to speed up product creation and updates.",
    owner: "Austin Dick",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ad-product-templates-for-brands.png",
    creationTool: "claude-code",
  },
  {
    id: "inventory-insights-in-product-m1",
    name: "Inventory Insights (in product) - M1",
    path: "/ad/inventory-insights-in-product-m1",
    description:
      'New "low stock" and "selling fast" signals — Brand Portal products table gains "Inventory" and "Recent sales" columns, plus a "Low stock" action card.',
    owner: "Austin Dick",
    createdAt: "2026-04-30",
    lastUpdated: "2026-04-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f0ca6bbadce7d122e8781c2904c2d1c79ac7cd18ebd7354a8ef29510b881408b.png",
    creationTool: "claude-code",
  },
  {
    id: "new-cc-homepage-banner",
    name: "Catalog Connect - Adoption Sprint 3",
    path: "/ad/new-cc-homepage-banner",
    description:
      "Full Catalog Connect adoption flow: homepage banner, products table with RTL tab, single product editor with typeahead, Add from URL modal, and Bulk Upload page with RTL hook.",
    owner: "Austin Dick",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/36c282a1f14290c3689622efee6b6130f8e8e6c23027b400209de134b1cf9b4b.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-portal-feed-homepage-concepts",
    name: "Brand Portal Feed-Oriented Homepage Concepts",
    path: "/ad/brand-portal-feed-homepage-concepts",
    description:
      "3 homepage directions for a feed-first brand portal: A) Command Center (user-controlled ordering, no AI), B) Copilot (AI drives the feed, drafts replies), C) Daily Ritual (streak + inbox-zero checklist).",
    owner: "Austin Dick",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6579e08bc81fabfd9acdb0fd2fad742b06040488d7c17262023604f43ebbad6d.png",
    creationTool: "claude-code",
  },
  {
    id: "products-page-template",
    name: "Products page template",
    path: "/ad/products-page-template",
    description:
      "Starter template for the Brand Portal Products page — scaffolded from Figma with a sidebar shell, page header, 3 metric action cards, and a full products table (tabs, search/filter, bulk actions, rows).",
    owner: "Austin Dick",
    createdAt: "2026-04-16",
    lastUpdated: "2026-04-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5abdd2a291e985eeff77a39284ef54a6b00128a23428159c136c4683a50c5908.png",
    figmaLink:
      "https://www.figma.com/design/o1y36iQgEl1CJEG4RzuWiS/%F0%9F%94%A5-Catalog-Connect-adoption-sprint?node-id=4419-17716",
    creationTool: "claude-code",
  },
  {
    id: "resting-typeahead-suggestions",
    name: "Resting Typeahead Suggestions",
    path: "/ad/resting-typeahead-suggestions",
    description: "Exploring typeahead suggestion UX at rest state",
    owner: "Austin Dick",
    createdAt: "2026-04-15",
    lastUpdated: "2026-04-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b4f4098bae3fbff8113793eef613df0f8b72214ef44b71a011e4f87044e2b00d.png",
    creationTool: "claude-code",
  },
  {
    id: "ready-to-list",
    name: "Ready to List",
    path: "/ad/ready-to-list",
    description:
      "Products page with a Ready to List tab showing web-scraped products brands can import into their Faire catalog, with create draft, dismiss, bulk import, export, and search actions.",
    owner: "Austin Dick",
    createdAt: "2026-03-23",
    lastUpdated: "2026-03-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ae7af59637fe00e03348a3eb20382d3bfeb93c9064b9738ff55e2060fb2c2ed7.png",
    figmaLink:
      "https://www.figma.com/design/o1y36iQgEl1CJEG4RzuWiS/%F0%9F%94%A5-Catalog-Connect-adoption-sprint?node-id=3984-37112",
    creationTool: "cursor",
  },
  {
    id: "bulk-upload-export",
    name: "Export on Bulk Upload",
    path: "/ad/bulk-upload-export",
    description:
      "Redesign of the Bulk Upload page exposing upload, download template, and export catalog at the top level instead of behind a modal.",
    owner: "Austin Dick",
    createdAt: "2026-03-18",
    lastUpdated: "2026-03-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/977a9be0b62fa95cd2a75c30884bc4a37a08fdba59a9fdd2f77abe3ed77a8c91.png",
    creationTool: "cursor",
  },
  {
    id: "orders",
    name: "Orders",
    path: "/ad/orders",
    description:
      "Orders page for the brand portal with summary metrics, status filters, and a configurable orders table.",
    owner: "Austin",
    createdAt: "2026-03-09",
    lastUpdated: "2026-04-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/af9a9236a3754559a95124b3adb3ca141cb107f93d84ed4c5ed80cd09720d7dd.png",
    creationTool: "claude-code",
  },
  {
    id: "inventory-insights",
    name: "Inventory Insights",
    path: "/ad/inventory-insights",
    description:
      'Inventory alerts and signals like "Low stock" and "Selling fast" within the Products table to help brands manage and stay on top of their inventory on Faire.',
    owner: "Austin",
    createdAt: "2026-03-06",
    lastUpdated: "2026-04-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2de8d257a10f44d73e697dde4a0b5ac06048158da39fb174c57f1f24c2b7f3e0.png",
    creationTool: "claude-code",
  },
  {
    id: "table-builder",
    name: "Table Builder",
    path: "/ad/table-builder",
    description:
      "An interactive tool for configuring and editing tables using the Slate Tables framework. Add columns, set types, edit cells inline.",
    owner: "Austin",
    createdAt: "2026-02-25",
    lastUpdated: "2026-04-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1ac202b820e403f76ebe3e33a6bbe483042c50c9d7f7e9f6ed47ab6f6a246f48.png",
    creationTool: "cursor",
  },
  {
    id: "the-future-of-products",
    name: "The future of Products",
    path: "",
    externalUrl: "https://mince-video-49192662.figma.site",
    description:
      'A reimagining of the Products ecosystem in the brand portal that seamlessly integrates "Ready to list" products, making them instantly accessibly and highly actionable.',
    owner: "Austin",
    createdAt: "2026-02-05",
    lastUpdated: "2026-03-06",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/49421dd80c70620c75da27d7729f3bd0630df262357030f0d2f07b960bdb3ab2.png",
    creationTool: "figma-make",
  },
  {
    id: "better-image-uploading-in-spe",
    name: "Better image uploading in SPE",
    path: "",
    externalUrl: "https://genre-divide-63851282.figma.site/",
    description:
      "- Add 5 themed image sets (beauty, food, home, outdoor, paper) with 4 images each that rotate in the hero section - Implement sequential fade-out/fade",
    owner: "Austin",
    createdAt: "2026-01-27",
    lastUpdated: "2026-01-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b192034c0da5dd08b01e26eb86b4120c17e05dc15d56b2ea943dc3643c494ea6.png",
    creationTool: "figma-make",
  },
  {
    id: "prepacks-table-configurator",
    name: "Prepacks table configurator",
    path: "",
    externalUrl: "https://ship-load-19149386.figma.site/",
    description:
      "Adds rotating hero image sets to the Upmarket Retailer Landing page (v7). The hero section now cycles through 5 category-themed image sets:",
    owner: "Austin",
    createdAt: "2026-01-27",
    lastUpdated: "2026-01-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6e5725c7f68452fa72136df21117f0ff2fd6cce426e756dc230e2b06c867ae81.png",
    creationTool: "figma-make",
  },
  {
    id: "products-table-2",
    name: "Products Table 2.0",
    path: "/ad/faire/products-table-2",
    description:
      'Redesigned Products table for the Brand Portal featuring improved inventory visibility, quick filters (Low stock, Out of stock, Selling fast), bulk actions, column sorting, and actionable opportunities. Includes Recent Sales column with "Selling fast" indicators.',
    owner: "Austin",
    createdAt: "2026-01-13",
    lastUpdated: "2026-01-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/37b69cc3df49c23928c525d2be1681c3a1c1cf53015cee310ba9915473dd4ded.png",
    creationTool: "claude-code",
  },
  {
    id: "false-out-of-stock-nudge",
    name: "False Out of Stock Nudge",
    path: "/ad/faire/false-out-of-stock-nudge",
    description:
      'Workflow to help brands resolve inventory mismatches between Faire and their consumer website. Features a banner alert, two-step modal flow for triaging products (Mark "In stock" or "Ignore"), and reason collection for ignored items. Built on Products Table 2.0.',
    owner: "Austin",
    createdAt: "2026-01-14",
    lastUpdated: "2026-01-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/68bae29d83740266d846d8c734742e75cbbeea74d89ba9f1ab73d0a5960926b3.png",
    creationTool: "cursor",
  },
  {
    id: "cc-loading-modal-sequence",
    name: "CC Loading Modal Sequence",
    path: "/ad/cc-loading-modal-sequence",
    description:
      "Multi-step loading modal sequence that plays while a draft is being created when a brand imports a product from their website into Faire via Catalog Connect.",
    owner: "Austin Dick",
    createdAt: "2026-03-19",
    lastUpdated: "2026-03-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/15958a471c73770c97af02a538f3a9240e22141a03ac31c1d2b92aa90442cc47.png",
    figmaLink:
      "https://www.figma.com/design/o1y36iQgEl1CJEG4RzuWiS/%F0%9F%94%A5-Catalog-Connect-adoption-sprint?node-id=3998-27651",
    creationTool: "cursor",
  },
  {
    id: "ad-bulk-upload-status-grouping",
    name: "Bulk Upload Results — Status Grouping",
    path: "/ad/bulk-upload-status-grouping",
    description:
      "Simplified action-based grouping for bulk upload results: ready to publish, missing fields, published, failed",
    owner: "Austin Dick",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1501915e2bd381d5adb0a5afac5883e06b554b38b8947ff154f80a9b8605dd61.png",
  },
  {
    id: "ad-pop-up-shop-name-generator",
    name: "Pop-up Shop Name Generator",
    path: "/ad/pop-up-shop-name-generator",
    description:
      "Combines a Canadian-ism with a Mercantile alternative into pop-up shop names. Generate, copy, edit, and lock either half.",
    owner: "Austin Dick",
    createdAt: "2026-10-01",
    lastUpdated: "2026-10-01",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/ad-pop-up-shop-name-generator.png",
  },
];
